export const environment = {
  production: true,
  apiUrl: 'http://localhost:7000',
  clientSecret: 'V9XMtsfnNeeFV2jDzrXqJf6eg2X1HtqbMoDeUdWz'
};
